import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Spin } from 'antd';
import { makeRequest } from '@utils/helpers';
import { getAttendanceSummaryReq } from '../requests';
import "../dashboard.css"
import ReactApexChart from 'react-apexcharts';
import { InputDate } from '@comps/components';
import dayjs from 'dayjs';
import useInViewport from '../useInViewport';
const moment = require('moment');

const AttendanceSummaryReport = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(moment().startOf('month'));
  const [endDate, setEndDate] = useState(moment().endOf('month'));
  const viewRef = useRef(null);
  const viewport = useInViewport(viewRef);

  useEffect(() => {
    let payload = {
      "start_date": startDate ? startDate.format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD'),
      "end_date": endDate ? endDate.format('YYYY-MM-DD') : moment().endOf('month').format('YYYY-MM-DD'),
    }
    if (viewport && data.length === 0) {
      getData(payload);
    }
  }
    , [startDate, endDate, viewport]);

const getData=(payload)=>{
  makeRequest(setLoader, getAttendanceSummaryReq, payload, onSuccess, onError)
}
  const onSuccess = (data) => {
    setData(data.attendance_report);
  }

  const onError = (error) => {
  }

  const onChangeStartDate=(date)=>{
    setStartDate(date);
    let payload = {
      "start_date": date ? date.format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD'),
      "end_date": endDate ? endDate.format('YYYY-MM-DD') : moment().endOf('month').format('YYYY-MM-DD'),
    }
    getData(payload);
   
  }
  const onChangeEndDate=(date)=>{
    setEndDate(date);
    let payload = {
      "start_date": startDate ? startDate.format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD'),
      "end_date": date ? date.format('YYYY-MM-DD') : moment().endOf('month').format('YYYY-MM-DD'),
    }
    getData(payload);
   
  }
  const chartOptions = {
    // Define your chart options here
    series: [{
      name: 'Percent',
      data: data.values
    }],
    labels: data.labels,
    colors: ['#EB7900'],
    options: {
      chart: {
        height: 400,
        type: 'area'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },

    },
  };

  const summaryItems = [
    { label: 'Absents', value: data.absents, background: '#EA4335', textColor: '#FFF' },
    { label: 'Presents', value: data.presents, background: '#4079FC', textColor: '#FFF' },
    { label: 'Missing Punches', value: data.missings, background: '#EB7900', textColor: '#FFF' },
    { label: 'Late Arrivals', value: data.missings, background: 'rgba(64, 121, 252, 0.10)', textColor: '#1E2022', labelColor: '#4079FC' },
    { label: 'Short Duration', value: data.short_durations, background: 'rgba(64, 121, 252, 0.10)', textColor: '#1E2022', labelColor: '#4079FC' },
    { label: 'Early Left', value: data.early_lefts, background: 'rgba(64, 121, 252, 0.10)', textColor: '#1E2022', labelColor: '#4079FC' },
    { label: 'Relaxations', value: data.relaxations, background: 'rgba(64, 121, 252, 0.10)', textColor: '#1E2022', labelColor: '#4079FC' },
    { label: 'Leaves', value: data.leaves, background: 'rgba(64, 121, 252, 0.10)', textColor: '#1E2022', labelColor: '#4079FC' },
  ];

  return (
    <div className='widgetbox' ref={ viewRef }>
      <Row gutter={ [12, 12] } align='middle'>
        <Col xs={ 24 } lg={ 10 }>
          <h3>Attendance Summary</h3>
        </Col>
        <Col xs={ 24 } lg={ 14 }>
          <div className='changeDate attendanceSummaryDate'>
            <Row gutter={ [10, 10] }>
              <Col xs={ 24 } sm={ 12 }>
                <InputDate onChange={ onChangeStartDate } defaultValue={ dayjs(startDate) } placeholder="Start Date" />
              </Col>
              <Col xs={ 24 } sm={ 12 }>
                <InputDate onChange={ onChangeEndDate } defaultValue={ dayjs(endDate) } placeholder="End Date" />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <div className='widgetcontent attendanceSummaryContent'>
        <Spin spinning={ loader } tip="Loading...">
          <Row gutter={ [14, 14] }>
            { summaryItems.map((item) => (
              <Col xs={ 12 } sm={ 12 } md={ 8 } xl={ 6 } xxl={ 3 } key={ item.label }>
                <div className='attendancSbox' style={ {
                  background: item.background,
                  color: item.textColor,
                } }>
                  <h4 style={ { color: item.labelColor || item.textColor } }>{ item.label }</h4>
                  <h3 style={ { color: item.textColor } }>{ item.value ?? 0 }</h3>
                </div>
              </Col>
            )) }
          </Row>
        </Spin>
      </div>
    </div>
  );
}

export default AttendanceSummaryReport;
